import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalWrapper, ModalHeader, ModalBody, ModalFooter } from '../../../../components/ui/modal-wrapper';
const InfoDialog = ({ isOpen, data, onClose }) => {
    if (!isOpen || !data)
        return null;
    const { title = 'Information', message, dismissText = 'OK', onDismiss } = data;
    const handleDismiss = () => {
        onDismiss?.();
        onClose();
    };
    return (_jsxs(ModalWrapper, { size: "sm", children: [_jsx(ModalHeader, { onClose: handleDismiss, children: title }), _jsx(ModalBody, { children: _jsx("p", { className: "text-sm text-muted-foreground", children: message }) }), _jsx(ModalFooter, { children: _jsx("button", { type: "button", onClick: handleDismiss, className: "inline-flex items-center justify-center rounded-md text-sm font-medium h-9 px-4 py-2 bg-primary text-primary-foreground hover:bg-primary/90 transition-colors", children: dismissText }) })] }));
};
export default InfoDialog;
